var VIDEO_PLAY = {
    HOVER: 'hover',
    AUTO: 'auto',
    ON_CLICK: 'onClick',
};
export default VIDEO_PLAY;
//# sourceMappingURL=videoPlay.js.map